module.exports = __webpack_public_path__ + "img/3.02af7fb2.png";